<!--
  Copyright 2021 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page">
  <ground-header></ground-header>

  <h1 class="page-title">Surveys</h1>

  <div class="container">
    <div class="surveys-container">
      <mat-card
        appearance="raised"
        id="add-card"
        class="survey-card new-survey-card"
        (click)="onNewSurvey()"
      >
        <mat-card-header>
          <div class="add-icon-container">
            <mat-icon mat-card-avatar class="add-icon">add_24px</mat-icon>
          </div>

          <mat-card-title class="survey-title">Create survey</mat-card-title>

          <mat-card-subtitle class="survey-description">
            Define jobs and sites for data collectors
          </mat-card-subtitle
          >
        </mat-card-header>
      </mat-card>

      <mat-card
        appearance="raised"
        *ngFor="let survey of surveys; let i = index"
        id="survey-card-{{ i }}"
        class="survey-card"
        (click)="onSurveyClicked(survey)"
      >
        <mat-card-header>
          <mat-card-title class="survey-title">{{
            survey.title
          }}</mat-card-title>

          <mat-card-subtitle class="survey-description">
            {{ survey.description }}
          </mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </div>
  </div>
</div>
